import React, { useEffect, useState } from 'react';
import styles from './license-buy.module.scss';
import { RangeInput } from 'shared/ui';
import { PaymentsTable } from './payments-table';
import { LicenseCalcComponent } from 'features/index';
import { userStore } from 'entities/index';
import { IGetLicenseInfoProps } from 'shared/api/business/interfaces/get-license-info.props.interface';
import { BusinessApi } from 'shared/api';

export const LicenseBuy: React.FC = () => {
  const [selectedDuration, setSelectedDuration] = useState(3);
  const [selectedEmployees, setSelectedEmployees] = useState(
    userStore.employeesCount < 2 ? 2 : userStore.employeesCount
    // userStore.licEmployeeLimit < 15 ? userStore.licEmployeeLimit + 1 : 15
  );
  const [license, setLicense] = useState<IGetLicenseInfoProps>();
  useEffect(() => {
    BusinessApi.getOwnerLicenseInfo()
      .then((data) => {
        setLicense(data);
      })
      .catch(() => {
        // ошибка загрузки лицензии — компонент покажет пустое состояние
      });
  }, []);

  return (
    <div className={styles.license__container}>
      <div className={styles.container__content}>
        <div className={styles.content__title}>Подписка</div>
        <div className={styles.content__license_info}>
          {userStore.licExpireDays > 1 ? (
            <div className={styles.license_info__block}>
              <div className={styles.block__text}>Активна</div>
              <div className={styles.block__number}>
                {userStore.licExpireDays} д.
              </div>
            </div>
          ) : (
            <div className={styles.license_info__block}>
              <div className={styles.block__text}>Не активна</div>
              {userStore.licExpireDays > 0 ? (
                <div className={styles.block__number}>
                  {Math.abs(userStore.licExpireDays)} д.
                </div>
              ) : null}
            </div>
          )}
          <div className={styles.license_info__block}>
            <div className={styles.block__text}>Cотрудников</div>
            <div className={styles.block__number}>
              {userStore.employeesCount} из {userStore.licEmployeeLimit}
            </div>
          </div>
        </div>
        <div className={styles.content__license_settings}>
          <div className={styles.license_settings__input}>
            <div className={styles.input__title}>Месяцев</div>
            <div className={styles.input__input_range}>
              <RangeInput
                min={0}
                max={12}
                initialValue={selectedDuration}
                onChange={setSelectedDuration}
              />
            </div>
          </div>
          <div className={styles.license_settings__input}>
            <div className={styles.input__title}>Сотрудников</div>
            <div className={styles.input__input_range}>
              <RangeInput
                min={
                  userStore.employeesCount < 2 ? 2 : userStore.employeesCount
                }
                max={15}
                initialValue={
                  userStore.employeesCount < 2 ? 2 : userStore.employeesCount
                }
                onChange={setSelectedEmployees}
              />
            </div>
          </div>
        </div>
        <div className={styles.content__license_offer}>
          {license ? (
            <LicenseCalcComponent
              fromEmplCount={userStore.licEmployeeLimit}
              toEmplCount={selectedEmployees}
              diffDays={userStore.licExpireDays}
              monthCount={selectedDuration}
              licType={userStore.licType}
              License={license}
            />
          ) : null}
        </div>
        <PaymentsTable />
      </div>
    </div>
  );
};
